export default __webpack_public_path__ + "static/media/tab-content-image-03.6bf59091.jpg";